import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from '../../../Components/Styled'
import BiztantuLoader from '../../../Components/Loader'
import { ACTIVE_STATUS, ARRAY_SERIALIZER, checkIsActionDisabled, customerIdWidth, DEFAULT_PAGE_SIZE, handleValidateCodevalue, idWidth, ownerWidth, parentTaskIdWidth, searchEntity, statusWidth, TASK_STATUS, TASK_STATUS_CANCELLED, TASK_STATUS_CLOSED, taskSecondaryTypeWidth, whocolumnWidth } from '../../../Utility/constant'
import { useDispatch, useSelector } from 'react-redux'
import BiztantuSearch from '../../../Components/BiztantuSearch'
import { Button, Stack, Tooltip, Typography } from '@mui/material'
import { privateRoutesPath } from '../../../Routes'
import { requestgetAllTasks, requestGetTasksPaged } from '../../../Store/Tasks/action'
import SendNotification from '../../../Components/SendNotification'
import { createRequestData, getRequestDataWithoutToken, updateRequestData } from '../../../Utility/apiHelper'
import { useSnackbar } from 'notistack'
import SearchTaskComponent from './SearchTaskComponent'
import { useSearchExecutor } from '../../../Components/CustomHooks/useSearchExecutor'
import { GridRowModes } from '@mui/x-data-grid'
import addFollowUpIcon from '../../../Assets/images/add_followup.png'; 
import disabledFollowUpIcon from '../../../Assets/images/disabled_add_followup.png'; 
import moment from 'moment'
import LeadDialog from '../../../Components/LeadDialog'
import DataGridTable from '../../../Components/DataGrid'
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet'
import { requestHideLoader, requestShowLoader,requestShowDialogLoader,requestHideDialogLoader } from '../../../Store/Global/action'
import StatusChip from '../../../Components/StatusChip'
import RefreshIcon from '@mui/icons-material/Refresh';
import ActionableNoteCell from '../../../Components/ActionableNoteCell';
import AddActionableNoteDialog from '../../../Components/AddActionableNoteDialog';
import { stripHtmlAndWhitespace } from '../../../Utility/textHelper';
import { useIsMobile } from '../../../Utility/hooks/useIsMobile';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { resetSearch, setPreserveSearch, setSearch } from '../../../Store/SearchReducer/action'
import { resetState } from '../../../Utility/resetSearchFunction'
import { buildEntitySearchValues } from '../../../Utility/buildEntitySearchValues '
import { useEntitySearch } from '../../../Utility/hooks/useEntitySearch'
import { usePaginatedSearch } from '../../../Utility/hooks/usePaginatedSearch'
import './EditTask.css'
import './Tasks.css'
import useNavigation from '../../../Utility/hooks/useNavigation'

const TaskPage = () => {
    const [dataGridData, SetDataGridData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const isLoadingProgress = useSelector(state => state?.global?.isLoading);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    
    const tasks = useSelector(state => state?.tasks?.tasks)
    const pagedTasksData = useSelector(state => state?.tasks?.pagedTasks)
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const myTeam = useSelector(state => state?.owner?.Team);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    const lookupData = useSelector(state => state?.lookup?.lookupData);
    const taskStatusData = useMemo(() => {
        return lookupData?.find((item) => item?.name == TASK_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    }, [lookupData]);
    const taskSearch = useSelector((state) => state?.search?.task) || {};
    
    const { navigateTo } = useNavigation();
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
     const [rowModesModel, setRowModesModel] = useState({});
    const [selectionModel, setSelectionModel] = useState([]);

    const [isActivityDialogOpen, setIsActivityDialogOpen] = useState({
        isOpen: false,
        isReadOnly: false
    });
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [activityData, setActivityData] = useState({
        activityNote: '',
        nextFollowupDate: ''
    });
    const [latestActivity, setLatestActivity] = useState(null);
    const [requiredActivity, setRequiredActivity] = useState({
        activityNote: false
    });
    
    const isMobile = useIsMobile();
    const activityRef = useRef(null);


    const today = new Date();
    const daysAgo = new Date();
    daysAgo.setDate(today.getDate() - 90);

const preserveSearch = useSelector(
  state => state?.search?.preserveSearch?.[searchEntity?.task]
);
    
        const { updatedSearch, newList } = useMemo(() => 
                buildEntitySearchValues({
                    entity: searchEntity?.task,
                    currentUser,
                    specificRolePermission,
                    ownerlist,
                    myTeam,
                    statusData: taskStatusData,
                    daysAgo,
                    today,
                    isAllManage: specificRolePermission?.isAllTaskManage,
                    isTeamManage: specificRolePermission?.isTaskTeamManage,
                    internationalise,
                    handleValidateCodevalue,
                }), [currentUser, specificRolePermission, ownerlist, myTeam, taskStatusData, internationalise]);
        
    const isReady =
        (myTeam?.length > 0 || ownerlist?.length > 0) &&
        currentUser?.userId &&
        internationalise &&
        Object.keys(internationalise).length > 0
    
            useEffect(() => {
        setownerlistdropdown(newList);
        }, [newList]);
    
        useEntitySearch({
            entity: searchEntity?.task,
            preserveSearch,
            searchState: taskSearch,
            isReady,
            getInitialState: () => updatedSearch,
            fetchAction: (search) =>
            requestGetTasksPaged({
                params: {
                    ...buildSearchParams(search),
                    size: DEFAULT_PAGE_SIZE
                },
                paramsSerializer: ARRAY_SERIALIZER,
            }),
            });

    useEffect(() => {
        if (pagedTasksData?.content && pagedTasksData.content.length > 0) {
            const tasksData = (pagedTasksData.content || []).map((item) => {
                return {
                    ...item,
                    id: item?.id,
                    guid: item?.guid,
                    description: item?.description,
                    ownerId: item?.ownerId,
                    customerId: item?.customerId,
                    specialNote: item?.specialNote,
                    primaryType: item?.primaryType,
                    secondaryType: item?.secondaryType,
                    status: item?.status,
                    createdAt: item?.createdAt,
                    updatedAt: item?.updatedAt,
                }
            })
            SetDataGridData(tasksData)
        } else {
            SetDataGridData([])
        }
    }, [pagedTasksData])

    const handleChangeSearchField = (event) => {
                dispatch(setSearch(searchEntity?.task, {
                    ...taskSearch,
                    [event.target.name]: event.target.value,
                }));
            };

    const handleSelectOwner = (event, Owner) => {
        if ((!Owner || Owner.length === 0) && !specificRolePermission?.isAllTaskManage) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_SELECT_OWNER_WARNING"), { variant: "warning" });
        return;
        }
        dispatch(
            setSearch(searchEntity?.task, {
                selectedOwner: Owner,
                ownerName: Owner?.name
            })
        );
    }

    const handleResetSearch = () => {
          dispatch(
              resetSearch(searchEntity?.task,resetState(taskSearch, {
                selectedOwner: taskSearch?.selectedOwner,
                ownerId : taskSearch?.ownerId,
                ownerName: taskSearch?.ownerName
              })
            )
          );
        };

    const { buildSearchParams, executeSearch } = useSearchExecutor({
        ownerlist,
        myTeam,
        setIsLoading,
        enqueueSnackbar,
        internationalise,
        handleValidateCodevalue,
    });



    const {
        paginationState,
        search: handleSearchTaskPaged,
        changePage: handlePageChange,
        changePageSize: handlePageSizeChange,
    } = usePaginatedSearch({
        executeSearch,
        buildParams: () => buildSearchParams(taskSearch),
        searchAction: requestGetTasksPaged,
    });



    const handleNotifyTaskFromTaskPage = async (tasks, selectedTaskIds) => {
        const selectedTasks =
            tasks?.filter(task => selectedTaskIds?.includes(task?.id)) || [];

        const hasValidTask = selectedTasks.some(
            task => !!task?.customerId
        );

        if (!hasValidTask) {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_CUSTOMER_REQUIRED"
                ),
                { variant: "warning" }
            );
            return;
        }

        const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification`;
        const responseData = await getRequestDataWithoutToken(url);
        const { data } = responseData;

        const filterData =
            data?.filter(item => item?.systemTemplateFlag !== "COMMON_YES") || [];

        const selectedDetails = selectedTasks.map(task => task?.customerId);

        setIsOpenNotificationDialog({
            selectedDetails,
            isOpen: true,
            templates: filterData
        });
    };

    const [isOpenNotificationDialog, setIsOpenNotificationDialog] = useState({
        isOpen: false,
        templates: [],
        selectedDetails: []
    })

    const handleBulkEmailSent = async () => {
        const selectedTasks =
            dataGridData?.filter(task => selectionModel?.includes(task?.id)) || [];
            
        for (const task of selectedTasks) {
            const payload = {
                taskId: task.id,
                status: task.status,
                note: "TASK_ACTIVITY_EMAIL_SENT",
                nextFollowupDate: null
            };
            // Reuse logic similar to createRequestData but silent/custom error handling if needed
            // Or just fire and forget, or collect promises
             try {
                const url = `${process.env.REACT_APP_BASE_URL}task-activities/create`
                await createRequestData(payload,url)
            } catch (e) {
                console.error("Failed to log activity for task", task.id, e);
            }
        }
        enqueueSnackbar(handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_ADDED_SUCCESSFULLY'), { variant: 'success' });
        handleSearchTaskPaged(paginationState.page);
    };

    const taskSearchBox = {
        ...taskSearch,
    }


   
    const handleEditTask =(taskOrId) => {
        const id = typeof taskOrId === 'object' ? taskOrId?.id : taskOrId;
        if (!id) return;
        
    navigateTo(`${privateRoutesPath.EDIT_TASK}/${id}`,{},searchEntity?.task);
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    };

    const handleUpdateTask = async (updatedTask) => {
        try {
                const { createdAt, updatedAt, ...payload } = updatedTask;
            dispatch(requestShowLoader())
            const url = `${process.env.REACT_APP_BASE_URL}tasks/${updatedTask.id}`;
            const response = await updateRequestData(payload, url);

            if (response?.status === 200) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_UPDATED_SUCCESSFULLY'), { variant: 'success' });
                handleSearchTaskPaged(paginationState.page)
            }
        } catch (error) {
            if (error?.response?.status !== 401) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        }
        finally{
            dispatch(requestHideLoader())
        }
    };

    const processRowUpdate = (newRow, oldRow) => {
        if (JSON.stringify(newRow) == JSON.stringify(oldRow)) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_NO_DATA_CHANGED'), { variant: 'info' });
            return oldRow; 
        } else {
            handleUpdateTask(newRow);
            const updatedRow = { ...newRow, isNew: false };
           
            return updatedRow;
        }
    };

    const handleActivityClick = useCallback((taskId, status, latestData, isReadOnly = false) => {
        setSelectedTaskId(taskId);
        setIsActivityDialogOpen({
            isOpen: true,
            isReadOnly: isReadOnly
        });
        setActivityData({ activityNote: '', nextFollowupDate: '', status: status });
        setLatestActivity(latestData || null);
        setRequiredActivity({ activityNote: false });
    }, []);

    const handleCloseActivityDialog = () => {
        setIsActivityDialogOpen({
            isOpen: false,
            isReadOnly: false
        });
        setSelectedTaskId(null);
        setActivityData({ activityNote: '', nextFollowupDate: '' });
        setLatestActivity(null);
        setRequiredActivity({ activityNote: false });
    };

    const handleActivityChange = (event) => {
        const { name, value } = event.target;
        setActivityData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveActivity = async () => {
        if (!activityData?.activityNote) {
            setRequiredActivity({ activityNote: true });
            activityRef?.current?.focus();
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            return;
        }

        try {
            dispatch(requestShowLoader())
            const payload = {
                taskId: parseInt(selectedTaskId),
                status: activityData.status,
                note: activityData.activityNote,
                nextFollowupDate: activityData.nextFollowupDate || null
            };

            const url = `${process.env.REACT_APP_BASE_URL}task-activities/create`
            const response = await createRequestData(payload,url)

            enqueueSnackbar(handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_ADDED_SUCCESSFULLY'), { variant: 'success' });
            handleCloseActivityDialog();
            handleSearchTaskPaged(paginationState.page); 
        } catch (error) {
            if (error?.response?.status !== 401) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        }
        finally{
            dispatch(requestHideLoader())
        }
    };
     const columns = useMemo(() => [

                {
                field: 'id',
                headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_TASK_ID'),
                flex: 1,
                minWidth: idWidth,
                editable: false,
                renderCell: (params) => (
                    <span
                        onClick={() => handleEditTask(params?.row)}
                        className="task-id-link"
                    >
                        {params?.id}
                    </span>
                )
            },
            {
                field: 'parentTaskId',
                headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_PARENT_TASK_ID'),
                flex: 1,
                minWidth: parentTaskIdWidth,
                editable: false,
                renderCell: (params) => {
                    const parentTaskId = params?.value ?? params?.row?.parentTaskId;
                    if (parentTaskId === null || parentTaskId === undefined || parentTaskId === '') {
                        return null;
                    }
                    return (
                        <span
                            onClick={() => handleEditTask(parentTaskId)}
                            className="task-id-link"
                        >
                            {parentTaskId}
                        </span>
                    );
                }
            },
            {
                field: 'description',
                headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_DESCRIPTION'),
                flex: 1,
                minWidth: 250,
                editable: true,
                renderCell: ({ value }) => {
                    const truncatedText = value && value.length > 40
                        ? `${value.substring(0, 40)}...`
                        : value;
    
                    return (
                        <Tooltip title={value || ''} arrow>
                            <span className="task-cell-truncate">
                                {truncatedText}
                            </span>
                        </Tooltip>
                    );
                }
            },
            {
                field: 'primaryType',
                headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_PT'),
                flex: 1,
                minWidth: statusWidth,
                editable: false,
                valueGetter: ({ value }) => {
                    if (!value) return "";
                    return handleValidateCodevalue(internationalise, value);
                }
            },
            {
                field: 'secondaryType',
                headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_ST'),
                flex: 1,
                minWidth:taskSecondaryTypeWidth,
                editable: false,
                valueGetter: ({ value }) => {
                    if (!value) return "";
                    return handleValidateCodevalue(internationalise, value);
                }
            },
               {
                field: 'source',
                headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_SOURCE'),
                flex: 1,
                minWidth: statusWidth,
                editable: false,
                valueGetter: ({ value }) => {
                    if (!value) return "";
                    return handleValidateCodevalue(internationalise, value);
                }
            },
            {
                field: 'priority',
                headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_PRIORITY'),
                flex: 1,
                minWidth: statusWidth,
                editable: false,
                renderCell: (params) => (
                    <StatusChip
                        chipType="priority"
                        status={params.row.priority}
                        internationalise={internationalise}
                    />
                )
            },
            {
                field: 'status',
                headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_STATUS'),
                flex: 1,
                minWidth: statusWidth,
                editable: false,
                renderCell: (params) => (
                    <StatusChip
                        isLead = {false}
                        systemLookup = {params?.row?.systemLookUpCodeStatus}
                        status={params.row.status}
                        internationalise={internationalise}
                    />)

            },
           {
        field: 'ownerId',
        minWidth: ownerWidth,
        headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => {
            if (!value) return '';
            const owner = ownerlist?.find(item => item?.id === value);
            return owner ? `${owner?.firstName || ''} ${owner?.lastName || ''}`.trim() : '';
        }
    },
    
            {
                field: 'customerId',
                headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_CUSTOMER'),
                flex: 1,
                minWidth: customerIdWidth,
                editable: false,
            },
          {
        field: 'taskActivities',
        headerName: handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_NOTE'),
        flex: 1,
        editable: false,
        minWidth: 200,
        renderCell: (params) => {
            const { value, row } = params;
            
            const isDisabled = checkIsActionDisabled(
                taskStatusData, 
                row?.status, 
                TASK_STATUS_CLOSED, 
                TASK_STATUS_CANCELLED, 
                specificRolePermission?.isTaskManage
            );

            const sortedActivities = value && Array.isArray(value) 
                ? [...value].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                : [];
            
            const latestNoteRaw = sortedActivities.length > 0 ? sortedActivities[0].note : "";
            const latestNote = stripHtmlAndWhitespace(latestNoteRaw);
            
            const truncatedText = latestNote.length > 30
                ? `${latestNote.substring(0, 30)}...` 
                : latestNote;
            
            return (
                <ActionableNoteCell 
                    truncatedText={truncatedText}
                    isDisabled={isDisabled}
                    onClick={() => handleActivityClick(
                        row.id, 
                        row.status, 
                        sortedActivities[0], 
                        isDisabled
                    )}
                    tooltipTitle={handleValidateCodevalue(internationalise, 'TASK_SEARCH_ADD_ACTIVITY')}
                    iconActive={addFollowUpIcon}
                    iconDisabled={disabledFollowUpIcon}
                    altText="add activity"
                />
            );
        }
    },
    
            {
                field: 'createdAt',
                headerName: handleValidateCodevalue(internationalise, 'COMMON_CREATED_AT'),
                type: 'date',
                minWidth: whocolumnWidth,
                flex: 1,
                editable: false,
                valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
            },
            {
                field: 'updatedAt',
                type: 'date',
                headerName: handleValidateCodevalue(internationalise, 'COMMON_UPDATED_AT'),
                flex: 1,
                editable: false,
                minWidth: whocolumnWidth,
                valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
            },
        ], [
            internationalise,
            handleEditTask,
            ownerlist,
            taskStatusData,
            specificRolePermission,
            handleActivityClick,
        ]);

    const [isOpenDialog,setIsOpenDialog] = useState({
        selectedOwner : null,
        isOpen : false
    })

    const handleOpenReAssignDialog = () =>{
        setIsOpenDialog({
            isOpen : true,
        })
    }
    const handleOnChangeOwner = (event,Owner) =>{
        setIsOpenDialog(prev=>({
           ...prev,
            selectedOwner : Owner
        }))
    }
    const handleReassign= async()=>{
        dispatch(requestShowDialogLoader())
    const rowsData = dataGridData.filter(function(item){
        return selectionModel.indexOf(item.id) !== -1;
      });
      const reqPayload = rowsData.filter((item, index) => item?.ownerId != isOpenDialog?.selectedOwner?.id);
     const payload = reqPayload.map(item => {
        return {
          id: item?.id,
          ownerId: isOpenDialog?.selectedOwner?.id
        }
      })
    
      const response = await updateRequestData(payload,"tasks/assign");

        if (response?.status === "error") {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    response?.propererror?.data?.summary || "COMMON_PLEASE_TRY_AGAIN"
                ),
                { variant: "error" }
            );
            return;
        }

        enqueueSnackbar(
            `${response?.data?.success} ${handleValidateCodevalue(
                internationalise,
                "TASK_ASSIGNED_TO"
            )} ${isOpenDialog?.selectedOwner?.firstName} ${isOpenDialog?.selectedOwner?.lastName}`,
            { variant: "success" }
        );

        handleCloseDialog();
        handleSearchTaskPaged(paginationState.page)
            
        dispatch(requestHideDialogLoader())
  }
   const handleCloseDialog = () => {
      setIsOpenDialog({
        isOpen : false,
        selectedOwner : false
      })
  }
  const handleSelectAutocomplete = (e,value,name)=>{
          dispatch(setSearch(searchEntity?.task, {
              ...taskSearch,
              [name] : value
          }));
    }

  const handleCreateTask = () => {
    dispatch(setPreserveSearch(searchEntity.task, true));
    navigateTo(privateRoutesPath.TASKS_CREATE,{},searchEntity?.task);
  }

  const renderValuesOnCard = [
  { field: "status", useLabel: true,left : true,useChip : true,chipType : "status" },
  { field: "priority", useLabel: true ,right : true,useChip : true , chipType : "priority"},
  { field: "description", stripHtml: true, truncate: true },
]
    return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
            <StyledDiv>
                <StyledLeadContainer>
                    <Typography variant='h6' className='mb-20'>
                        {handleValidateCodevalue(internationalise, 'TASKS_SEARCH_TITLE')}
                    </Typography>
                </StyledLeadContainer>
                <StyledIndexContainerDiv>
                    <StyledLeadContainer className="tasks-filter-container">
                        <Stack 
                            width={isMobile ? "100%" : "30%"}
                            className='table-header-search table-header-search-common' 
                            flexWrap={isMobile ? "nowrap" : ""} 
                            flexDirection = {isMobile ? "row" : ""}
                            alignItems = "center"
                            justifyContent={isMobile ? "space-between" : ""}
                            mb = {isMobile ? 2 : 0}
                            bgcolor = {isMobile ? "#F4F9FE" : "#FFFFFF"}
                        >
                            <BiztantuSearch
                                showStatus={false}
                                showOwner={true}
                                entityDetails={taskSearchBox}
                                ownerlistdropdown={ownerlistdropdown}
                                handleReset={handleResetSearch}
                                handleSearch={() => handleSearchTaskPaged(0)}
                            >
                                <SearchTaskComponent
                                    handleSelectStatus = {handleSelectAutocomplete}
                                    handleSelectOwner={handleSelectOwner}
                                    ownerlistdropdown={ownerlistdropdown}
                                    entityDetails={taskSearch}
                                    handleOnChange={handleChangeSearchField}
                                />
                            </BiztantuSearch>
                            {isMobile &&
                            <Stack className='mb-10' flexDirection={"row"} display={"flex"} justifyContent={"space-between"} gap = {2}>
                            <Tooltip
                                title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}
                                onClick={() => handleSearchTaskPaged(paginationState.page)}
                                >
                                <Button
                                    className='biztantu-sec-btn-mobile'
                                    variant="outlined"
                                >
                                <RefreshIcon />
                                </Button>
                            </Tooltip>
                            <Tooltip
                                title={handleValidateCodevalue(internationalise, 'TASK_CREATE')}
                                onClick={handleCreateTask}
                                >
                                <Button
                                    className='biztantu-sec-btn-mobile'
                                    variant="outlined"
                                >
                                <AddIcon />
                                </Button>
                            </Tooltip>
                            </Stack>
                            }
                        </Stack>
                        
                        <Stack className='secondry-btn-container' width="60%" padding="10px" spacing={2} direction="row" 
                        sx={{
                            justifyContent: {
                            xs: "flex-start", 
                            sm: "flex-start",
                            md: "flex-end"   
                            }
                        }} >
                            
                        {(specificRolePermission?.isTaskManage && !isMobile) &&
                            <>
                            <Tooltip
                                title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}
                                onClick={() => handleSearchTaskPaged(paginationState.page)}
                                >
                                <Button
                                    className="biztantu-sec-btn"
                                    variant="outlined"
                                >
                                <RefreshIcon />
                                </Button>
                            </Tooltip>
                            <Button
                                // startIcon={<img src={createicon} style={{ height: "15px" }} />}
                                className='biztantu-sec-btn'
                                variant="outlined"
                                onClick={handleCreateTask}
                            >
                                {handleValidateCodevalue(internationalise, 'TASK_CREATE')}
                            </Button>
                            </>
                        }
                        </Stack>
                    </StyledLeadContainer>
                   <DataGridTable
                   showMobileFooter = {true}
                   isSearchScreen = {true}
                    renderValuesOnCard = {renderValuesOnCard}
                    handleOnClickCard = {handleEditTask}
                    isTaskScreen={true}
                    handleOnClickTableAction = {handleOpenReAssignDialog}
                    dataGridData={dataGridData}
                    isLoading={isLoading}
                    columns={columns}

                    selectionModel={selectionModel}
                    setSelectionModel={setSelectionModel}
                    isCheckboxReq={true}

                    isRequiredToolBar={specificRolePermission?.isTaskManage} 
                    gridType="task"
                    
                    handleNotifyUser={() => handleNotifyTaskFromTaskPage(dataGridData, selectionModel)}
                    
                    rowModesModel={rowModesModel}
                    handleProcessRowUpdate={processRowUpdate}
                    
                    height="calc(100vh - 218px)"
                    marginTop="0px"

                    pagedData={pagedTasksData}
                    paginationState={paginationState}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
                </StyledIndexContainerDiv>

                {
                    (isOpenNotificationDialog?.isOpen) && (
                        <SendNotification
                            open={isOpenNotificationDialog?.isOpen}
                            title={handleValidateCodevalue(internationalise, "COMMON_NOTIFY_CUSTOMER")}
                            dataGridData={isOpenNotificationDialog?.templates}
                            selectedDetails={isOpenNotificationDialog?.selectedDetails}
                            setIsOpenNotificationDialog={setIsOpenNotificationDialog}
                            type={"Customer"}
                            handleSuccess={handleBulkEmailSent}
                        />
                    )
                }
                 {
                isOpenDialog?.isOpen && (
                    <LeadDialog 
                        open = {isOpenDialog?.isOpen}
                        handleClose = {handleCloseDialog}
                        title= {handleValidateCodevalue(internationalise,"TASK_REASSIGN_TITLE")}
                        size="sm"
                        selectedowner={isOpenDialog?.selectedOwner}
                        btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                        handleSave={handleReassign}
                    >
                    <AutoCompleteComponent
                      isOwner = {true}
                      optionSet = {(specificRolePermission?.isAllTaskManage ? ownerlist : specificRolePermission?.isTaskTeamManage ? myTeam: ownerlist) || []}
                      value={isOpenDialog?.selectedOwner || null}
                      name = "managerId"
                      placeholder={handleValidateCodevalue(internationalise,"TASK_REASSIGN_SELECT_OWNER")}
                      disabled = {!(specificRolePermission?.isAllTaskManage || specificRolePermission.isTaskTeamManage)}
                      label={handleValidateCodevalue(internationalise,'TASK_REASSIGN_SELECT_OWNER')}
                      onChange={(event, Owner) => handleOnChangeOwner(event, Owner)}
                      />
                        
                    </LeadDialog>
                )
            }

           {isActivityDialogOpen?.isOpen && (
                <AddActionableNoteDialog
                    open={isActivityDialogOpen?.isOpen}
                    handleClose={handleCloseActivityDialog}
                    title={handleValidateCodevalue(internationalise, "TASK_ADD_ACTIVITY")}
                    btnLabel={handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
                    handleSave={handleSaveActivity}
                    latestRecord={latestActivity ? {
                        ...latestActivity,
                        note: handleValidateCodevalue(internationalise, latestActivity.note),
                        date: latestActivity.nextFollowupDate
                    } : null}
                    latestRecordTitle={handleValidateCodevalue(internationalise, "TASK_ACTIVITY_NOTE") || "Latest Activity"}
                    latestNoteLabel={handleValidateCodevalue(internationalise, "TASK_EDIT_ACTIVITY_NOTE")}
                    latestDateLabel={handleValidateCodevalue(internationalise, "TASK_NEXT_FOLLOWUP_DATE")}
                    newRecordTitle={handleValidateCodevalue(internationalise, "TASK_WANT_TO_ADD_NEW_NOTE") || "Wants to add new note"}
                    newNoteLabel={handleValidateCodevalue(internationalise, "TASK_EDIT_ACTIVITY_NOTE")}
                    newNoteName="activityNote"
                    newNoteValue={activityData?.activityNote}
                    newDateLabel={handleValidateCodevalue(internationalise, "TASK_NEXT_FOLLOWUP_DATE")}
                    newDateName="nextFollowupDate"
                    newDateValue={activityData?.nextFollowupDate}
                    handleOnChange={handleActivityChange}
                    noteError={activityData?.activityNote ? false : requiredActivity?.activityNote}
                    readOnly={isActivityDialogOpen?.isReadOnly}
                />
            )}
            </StyledDiv>
        </BiztantuLoader>
    )
}

export default TaskPage
